import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function metadataReducer(state = initialState.metadata, action) {
  switch (action.type) {
    case types.LOAD_METADATA_SUCCESS:
      return { ...state, [action.metadataType]: action.metadata };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/metadataReducer.js